import createContact from './createContact'
import updateContact from './updateContact'

import type { MutationResolvers } from '../generated/graphql'

const contacts: MutationResolvers = {
    createContact,
    updateContact,
}

export const contactResolvers = {
    Mutation: {
        ...contacts,
    },
}
